import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import * as ReactNative from "react-native-web/dist/index";
import PropTypes from 'prop-types';
import XDate from 'xdate';
import { parseDate, xdateToData } from "../interface";
import dateutils from "../dateutils";
import CalendarList from "../calendar-list";
import ReservationsList from "./reservation-list";
import styleConstructor from "./style";
import { VelocityTracker } from "../input";
import { AGENDA_CALENDAR_KNOB } from "../testIDs";
import { jsx as ___EmotionJSX } from "@emotion/core";
var HEADER_HEIGHT = 104;
var KNOB_HEIGHT = 24;
var Text = ReactNative.Text,
    View = ReactNative.View,
    Dimensions = ReactNative.Dimensions,
    Animated = ReactNative.Animated,
    ViewPropTypes = ReactNative.ViewPropTypes;
var viewPropTypes = ViewPropTypes || View.propTypes;

var AgendaView = function (_Component) {
  _inherits(AgendaView, _Component);

  var _super = _createSuper(AgendaView);

  function AgendaView(props) {
    var _this;

    _classCallCheck(this, AgendaView);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "initialScrollPadPosition", function () {
      return Math.max(0, _this.viewHeight - HEADER_HEIGHT);
    });

    _defineProperty(_assertThisInitialized(_this), "setScrollPadPosition", function (y, animated) {
      if (_this.scrollPad.scrollTo) {
        _this.scrollPad.scrollTo({
          x: 0,
          y: y,
          animated: animated
        });
      } else {
        _this.scrollPad.getNode().scrollTo({
          x: 0,
          y: y,
          animated: animated
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onScrollPadLayout", function () {
      _this.setScrollPadPosition(_this.initialScrollPadPosition(), false);

      setTimeout(function () {
        return _this.setState({
          calendarIsReady: true
        });
      }, 0);
    });

    _this.styles = styleConstructor(props.theme);
    var windowSize = Dimensions.get('window');
    _this.viewHeight = windowSize.height;
    _this.viewWidth = windowSize.width;
    _this.scrollTimeout = undefined;
    _this.headerState = 'idle';
    _this.state = {
      scrollY: new Animated.Value(0),
      calendarIsReady: false,
      calendarScrollable: false,
      firstResevationLoad: false,
      selectedDay: parseDate(_this.props.selected) || XDate(true),
      topDay: parseDate(_this.props.selected) || XDate(true)
    };
    _this.currentMonth = _this.state.selectedDay.clone();
    _this.onLayout = _this.onLayout.bind(_assertThisInitialized(_this));
    _this.onTouchStart = _this.onTouchStart.bind(_assertThisInitialized(_this));
    _this.onTouchEnd = _this.onTouchEnd.bind(_assertThisInitialized(_this));
    _this.onStartDrag = _this.onStartDrag.bind(_assertThisInitialized(_this));
    _this.onSnapAfterDrag = _this.onSnapAfterDrag.bind(_assertThisInitialized(_this));
    _this.generateMarkings = _this.generateMarkings.bind(_assertThisInitialized(_this));
    _this.knobTracker = new VelocityTracker();

    _this.state.scrollY.addListener(function (_ref) {
      var value = _ref.value;
      return _this.knobTracker.add(value);
    });

    return _this;
  }

  _createClass(AgendaView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      this.loadReservations(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.state.scrollY.removeAllListeners();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      if (props.items) {
        this.setState({
          firstResevationLoad: false
        });
      } else {
        this.loadReservations(props);
      }
    }
  }, {
    key: "calendarOffset",
    value: function calendarOffset() {
      return 96 - this.viewHeight / 2;
    }
  }, {
    key: "onLayout",
    value: function onLayout(event) {
      this.viewHeight = event.nativeEvent.layout.height;
      this.viewWidth = event.nativeEvent.layout.width;
      this.forceUpdate();
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart() {
      this.headerState = 'touched';

      if (this.knob) {
        this.knob.setNativeProps({
          style: {
            opacity: 0.5
          }
        });
      }
    }
  }, {
    key: "onTouchEnd",
    value: function onTouchEnd() {
      if (this.knob) {
        this.knob.setNativeProps({
          style: {
            opacity: 1
          }
        });
      }

      if (this.headerState === 'touched') {
        this.setScrollPadPosition(0, true);
        this.enableCalendarScrolling();
      }

      this.headerState = 'idle';
    }
  }, {
    key: "onStartDrag",
    value: function onStartDrag() {
      this.headerState = 'dragged';
      this.knobTracker.reset();
    }
  }, {
    key: "onSnapAfterDrag",
    value: function onSnapAfterDrag(e) {
      this.onTouchEnd();
      var currentY = e.nativeEvent.contentOffset.y;
      this.knobTracker.add(currentY);
      var projectedY = currentY + this.knobTracker.estimateSpeed() * 250;
      var maxY = this.initialScrollPadPosition();
      var snapY = projectedY > maxY / 2 ? maxY : 0;
      this.setScrollPadPosition(snapY, true);

      if (snapY === 0) {
        this.enableCalendarScrolling();
      }
    }
  }, {
    key: "onVisibleMonthsChange",
    value: function onVisibleMonthsChange(months) {
      var _this2 = this;

      if (this.props.onVisibleMonthsChange) {
        this.props.onVisibleMonthsChange(months);
      }

      if (this.props.items && !this.state.firstResevationLoad) {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(function () {
          if (_this2.props.loadItemsForMonth && _this2._isMounted) {
            _this2.props.loadItemsForMonth(months[0]);
          }
        }, 200);
      }
    }
  }, {
    key: "loadReservations",
    value: function loadReservations(props) {
      var _this3 = this;

      if ((!props.items || !Object.keys(props.items).length) && !this.state.firstResevationLoad) {
        this.setState({
          firstResevationLoad: true
        }, function () {
          if (_this3.props.loadItemsForMonth) {
            _this3.props.loadItemsForMonth(xdateToData(_this3.state.selectedDay));
          }
        });
      }
    }
  }, {
    key: "enableCalendarScrolling",
    value: function enableCalendarScrolling() {
      this.setState({
        calendarScrollable: true
      });

      if (this.props.onCalendarToggled) {
        this.props.onCalendarToggled(true);
      }

      this.calendar.scrollToDay(this.state.selectedDay, this.calendarOffset() + 1, true);
    }
  }, {
    key: "_chooseDayFromCalendar",
    value: function _chooseDayFromCalendar(d) {
      this.chooseDay(d, !this.state.calendarScrollable);
    }
  }, {
    key: "chooseDay",
    value: function chooseDay(d, optimisticScroll) {
      var day = parseDate(d);
      this.setState({
        calendarScrollable: false,
        selectedDay: day.clone()
      });

      if (this.props.onCalendarToggled) {
        this.props.onCalendarToggled(false);
      }

      if (!optimisticScroll) {
        this.setState({
          topDay: day.clone()
        });
      }

      this.setScrollPadPosition(this.initialScrollPadPosition(), true);
      this.calendar.scrollToDay(day, this.calendarOffset(), true);

      if (this.props.loadItemsForMonth) {
        this.props.loadItemsForMonth(xdateToData(day));
      }

      if (this.props.onDayPress) {
        this.props.onDayPress(xdateToData(day));
      }
    }
  }, {
    key: "renderReservations",
    value: function renderReservations() {
      var _this4 = this;

      return ___EmotionJSX(ReservationsList, {
        onScrollBeginDrag: this.props.onScrollBeginDrag,
        onScrollEndDrag: this.props.onScrollEndDrag,
        onMomentumScrollBegin: this.props.onMomentumScrollBegin,
        onMomentumScrollEnd: this.props.onMomentumScrollEnd,
        refreshControl: this.props.refreshControl,
        refreshing: this.props.refreshing,
        onRefresh: this.props.onRefresh,
        rowHasChanged: this.props.rowHasChanged,
        renderItem: this.props.renderItem,
        renderDay: this.props.renderDay,
        renderEmptyDate: this.props.renderEmptyDate,
        reservations: this.props.items,
        selectedDay: this.state.selectedDay,
        renderEmptyData: this.props.renderEmptyData,
        topDay: this.state.topDay,
        onDayChange: this.onDayChange.bind(this),
        onScroll: function onScroll() {},
        ref: function ref(c) {
          return _this4.list = c;
        },
        theme: this.props.theme
      });
    }
  }, {
    key: "onDayChange",
    value: function onDayChange(day) {
      var newDate = parseDate(day);
      var withAnimation = dateutils.sameMonth(newDate, this.state.selectedDay);
      this.calendar.scrollToDay(day, this.calendarOffset(), withAnimation);
      this.setState({
        selectedDay: parseDate(day)
      });

      if (this.props.onDayChange) {
        this.props.onDayChange(xdateToData(newDate));
      }
    }
  }, {
    key: "generateMarkings",
    value: function generateMarkings() {
      var _this5 = this;

      var markings = this.props.markedDates;

      if (!markings) {
        markings = {};
        Object.keys(this.props.items || {}).forEach(function (key) {
          if (_this5.props.items[key] && _this5.props.items[key].length) {
            markings[key] = {
              marked: true
            };
          }
        });
      }

      var key = this.state.selectedDay.toString('yyyy-MM-dd');
      return _objectSpread({}, markings, _defineProperty({}, key, _objectSpread({}, markings[key] || {}, {}, {
        selected: true
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var agendaHeight = this.initialScrollPadPosition();
      var weekDaysNames = dateutils.weekDayNames(this.props.firstDay);
      var weekdaysStyle = [this.styles.weekdays, {
        opacity: this.state.scrollY.interpolate({
          inputRange: [agendaHeight - HEADER_HEIGHT, agendaHeight],
          outputRange: [0, 1],
          extrapolate: 'clamp'
        }),
        transform: [{
          translateY: this.state.scrollY.interpolate({
            inputRange: [Math.max(0, agendaHeight - HEADER_HEIGHT), agendaHeight],
            outputRange: [-HEADER_HEIGHT, 0],
            extrapolate: 'clamp'
          })
        }]
      }];
      var headerTranslate = this.state.scrollY.interpolate({
        inputRange: [0, agendaHeight],
        outputRange: [agendaHeight, 0],
        extrapolate: 'clamp'
      });
      var contentTranslate = this.state.scrollY.interpolate({
        inputRange: [0, agendaHeight],
        outputRange: [0, agendaHeight / 2],
        extrapolate: 'clamp'
      });
      var headerStyle = [this.styles.header, {
        bottom: agendaHeight,
        transform: [{
          translateY: headerTranslate
        }]
      }];

      if (!this.state.calendarIsReady) {
        headerStyle.push({
          height: 0
        });
        weekdaysStyle.push({
          height: HEADER_HEIGHT
        });
      }

      var shouldAllowDragging = !this.props.hideKnob && !this.state.calendarScrollable;
      var scrollPadPosition = (shouldAllowDragging ? HEADER_HEIGHT : 0) - KNOB_HEIGHT;
      var scrollPadStyle = {
        position: 'absolute',
        width: 80,
        height: KNOB_HEIGHT,
        top: scrollPadPosition,
        left: (this.viewWidth - 80) / 2
      };

      var knob = ___EmotionJSX(View, {
        style: this.styles.knobContainer
      });

      if (!this.props.hideKnob) {
        var knobView = this.props.renderKnob ? this.props.renderKnob() : ___EmotionJSX(View, {
          style: this.styles.knob
        });
        knob = this.state.calendarScrollable ? null : ___EmotionJSX(View, {
          style: this.styles.knobContainer
        }, ___EmotionJSX(View, {
          ref: function ref(c) {
            return _this6.knob = c;
          }
        }, knobView));
      }

      var shouldHideExtraDays = this.state.calendarScrollable ? this.props.hideExtraDays : false;
      return ___EmotionJSX(View, {
        testID: this.props.testID,
        onLayout: this.onLayout,
        style: [this.props.style, {
          flex: 1,
          overflow: 'hidden'
        }]
      }, ___EmotionJSX(View, {
        style: this.styles.reservations
      }, this.renderReservations()), ___EmotionJSX(Animated.View, {
        style: headerStyle
      }, ___EmotionJSX(Animated.View, {
        style: {
          flex: 1,
          transform: [{
            translateY: contentTranslate
          }]
        }
      }, ___EmotionJSX(CalendarList, {
        onLayout: function onLayout() {
          _this6.calendar.scrollToDay(_this6.state.selectedDay.clone(), _this6.calendarOffset(), false);
        },
        calendarWidth: this.viewWidth,
        theme: this.props.theme,
        onVisibleMonthsChange: this.onVisibleMonthsChange.bind(this),
        ref: function ref(c) {
          return _this6.calendar = c;
        },
        minDate: this.props.minDate,
        maxDate: this.props.maxDate,
        current: this.currentMonth,
        markedDates: this.generateMarkings(),
        markingType: this.props.markingType,
        removeClippedSubviews: this.props.removeClippedSubviews,
        onDayPress: this._chooseDayFromCalendar.bind(this),
        scrollEnabled: this.state.calendarScrollable,
        hideExtraDays: shouldHideExtraDays,
        firstDay: this.props.firstDay,
        monthFormat: this.props.monthFormat,
        pastScrollRange: this.props.pastScrollRange,
        futureScrollRange: this.props.futureScrollRange,
        dayComponent: this.props.dayComponent,
        disabledByDefault: this.props.disabledByDefault,
        displayLoadingIndicator: this.props.displayLoadingIndicator,
        showWeekNumbers: this.props.showWeekNumbers
      })), knob), ___EmotionJSX(Animated.View, {
        style: weekdaysStyle
      }, this.props.showWeekNumbers && ___EmotionJSX(Text, {
        allowFontScaling: false,
        style: this.styles.weekday,
        numberOfLines: 1
      }), weekDaysNames.map(function (day, index) {
        return ___EmotionJSX(Text, {
          allowFontScaling: false,
          key: day + index,
          style: _this6.styles.weekday,
          numberOfLines: 1
        }, day);
      })), ___EmotionJSX(Animated.ScrollView, {
        ref: function ref(_ref2) {
          return _this6.scrollPad = _ref2;
        },
        overScrollMode: "never",
        showsHorizontalScrollIndicator: false,
        showsVerticalScrollIndicator: false,
        style: scrollPadStyle,
        scrollEventThrottle: 8,
        scrollsToTop: false,
        onTouchStart: this.onTouchStart,
        onTouchEnd: this.onTouchEnd,
        onScrollBeginDrag: this.onStartDrag,
        onScrollEndDrag: this.onSnapAfterDrag,
        onScroll: Animated.event([{
          nativeEvent: {
            contentOffset: {
              y: this.state.scrollY
            }
          }
        }], {
          useNativeDriver: true
        })
      }, ___EmotionJSX(View, {
        testID: AGENDA_CALENDAR_KNOB,
        style: {
          height: agendaHeight + KNOB_HEIGHT
        },
        onLayout: this.onScrollPadLayout
      })));
    }
  }]);

  return AgendaView;
}(Component);

_defineProperty(AgendaView, "displayName", 'Agenda');

_defineProperty(AgendaView, "propTypes", {
  theme: PropTypes.object,
  style: viewPropTypes.style,
  items: PropTypes.object,
  loadItemsForMonth: PropTypes.func,
  onCalendarToggled: PropTypes.func,
  onDayPress: PropTypes.func,
  onDaychange: PropTypes.func,
  renderItem: PropTypes.func,
  renderDay: PropTypes.func,
  renderKnob: PropTypes.func,
  renderEmptyDay: PropTypes.func,
  renderEmptyData: PropTypes.func,
  rowHasChanged: PropTypes.func,
  pastScrollRange: PropTypes.number,
  futureScrollRange: PropTypes.number,
  selected: PropTypes.any,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  firstDay: PropTypes.number,
  markedDates: PropTypes.object,
  markingType: PropTypes.string,
  hideKnob: PropTypes.bool,
  monthFormat: PropTypes.string,
  refreshControl: PropTypes.element,
  onRefresh: PropTypes.func,
  refreshing: PropTypes.bool,
  displayLoadingIndicator: PropTypes.bool,
  onScrollBeginDrag: PropTypes.func,
  onScrollEndDrag: PropTypes.func,
  onMomentumScrollBegin: PropTypes.func,
  onMomentumScrollEnd: PropTypes.func
});

export { AgendaView as default };

if (typeof AgendaView !== 'undefined' && AgendaView && AgendaView === Object(AgendaView) && Object.isExtensible(AgendaView) && !AgendaView.hasOwnProperty('__filemeta')) {
  Object.defineProperty(AgendaView, '__filemeta', {
    configurable: true,
    value: {
      name: "AgendaView",
      filename: "node_modules/react-native-calendars/src/agenda/index.js"
    }
  });
}

if (typeof AgendaView !== 'undefined' && AgendaView && AgendaView === Object(AgendaView) && Object.isExtensible(AgendaView) && !AgendaView.hasOwnProperty('__filemeta')) {
  Object.defineProperty(AgendaView, '__filemeta', {
    configurable: true,
    value: {
      name: "AgendaView",
      filename: "node_modules/react-native-calendars/src/agenda/index.js"
    }
  });
}